export default __webpack_public_path__ + "static/media/carafem-logo.f163de16.jpg";